


























































































































































import {Component, Watch, Model, Prop, Vue} from 'vue-property-decorator';
import {ComponentBase, Overlay, SvgIcon} from "@/modules/budget/staffing-table/components";
import i18n from "@/services/i18n";
import {BudgetVariants, Comp, SummaryReport} from "@/modules/budget/staffing-table/types";
import EnumStatus = SummaryReport.EnumStatus;
import GeneratorTypeEnum = SummaryReport.GeneratorTypeEnum
import axios from "axios";
import {dateTimeFormat} from "@/modules/budget/staffing-table/common";
import auth from "@/services/auth";
import {BootstrapVueIcons} from "bootstrap-vue";

const translates = {
    tableField: {
        get planPeriodTitle(): string {
            return i18n.choose('Плановый период', 'Плановый период (каз)', 'Plan period');
        },
        get reportTitle(): string {
            return i18n.choose('Отчет', 'Отчет (каз)', 'Report');
        },
        get regionTitle(): string {
            return i18n.choose('Регион', 'Регион (каз)', 'Region');
        },
        get dataTypeTitle(): string {
            return i18n.choose('Вид данных', 'Вид данных (каз)', 'Data Type');
        },

        get eduOrgTypeTitle(): string {
            return i18n.choose('Тип организации', 'Тип организации (каз)', 'organization type');
        },

        get codeGuTitle(): string {
            return i18n.choose('Отдел образования', 'Отдел образования (каз)', 'code organization');
        },

        get subGuCodesTitle(): string {
            return i18n.choose('Организации образования', 'Организации образования (каз)', 'organization education');
        },

        get abpTitle(): string {
            return i18n.choose('АБП', 'АБП (каз)', 'ABP');
        },

        get variantUuidTitle(): string {
            return i18n.choose('Вариант', 'Вариант (каз)', 'Variant');
        },

        get budgetProgramTitle(): string {
            return i18n.choose('БП', 'БП (каз)', 'BP');
        },

        get detailedReportTitle(): string {
            return i18n.choose('Расширенный', 'Расширенный (каз)', 'Expanded');
        },

        get includeDepartmentTitle(): string {
            return i18n.choose('В разрезе отделов', 'В разрезе отделов (каз)', 'Context of departments');
        },

        get statusTitle(): string {
            return i18n.choose('Статус', 'Статус (каз)', 'Status');
        },

        get userTitle(): string {
            return i18n.choose('Пользователь', 'Пользователь (каз)', 'User');
        },

        get createDateTitle(): string {
            return i18n.choose('Дата создания', 'Дата создания (каз)', 'Create date');
        },

        get exportDateTitle(): string {
            return i18n.choose('Дата загрузки', 'Дата загрузки (каз)', 'Export date');
        },

        get actionTitle(): string {
            return i18n.choose('', '', '');
        }
    },
    action: {
        get getProcessedTitle():string {
            return i18n.choose('ОБРАБОТАНО', 'ОБРАБОТАНО (каз)', 'PROCESSED');
        },

        get getInterruptedTitle():string {
            return i18n.choose('ПРЕРВАНО', 'ПРЕРВАНО (каз)', 'INTERRUPTED');
        },

        get getQueueITitle():string {
            return i18n.choose('В ОЧЕРЕДИ', 'В ОЧЕРЕДИ (каз)', 'IN QUEUE');
        },

        get getExportedTitle():string {
            return i18n.choose('ВЫГРУЖЕНО', 'ВЫГРУЖЕНО (каз)', 'EXPORTED');
        },

        get getRetryTitle():string {
            return i18n.choose('В ПОВТОРЕ', ' В ПОВТОРЕ (каз)', 'RETRY');
        },

        get getRefreshStatusTitle(): string {
            return i18n.choose(
                'Задача не может быть изменена в текущем статусе. Обновите статус задачи.',
                'Тапсырманы ағымдағы күйінде тоқтату мүмкін емес',
                'Refresh report statuses.'
            );
        },

        get getRequestedCancelTitle():string {
            return i18n.choose('ОТМЕНА ЗАГРУЗКИ', 'ЖҮКТЕУДІҢ БОЛДЫРЫЛУЫ', 'REQUESTED CANCEL');
        },

        get getTaskCanceledTitle():string {
            return i18n.choose('ПРЕРВАН ПОЛЬЗОВАТЕЛЕМ', 'ПАЙДАЛАНУШЫМЕН ТОҚТАТЫЛДЫ', 'CANCELED BY USER');
        },

        get getTaskFailRepairTitle(): string {
            return i18n.choose(
                'ОШИБКА ВОССТАНОВЛЕНИЯ',
                'ҚАЛПЫНА КЕЛТІРУ ҚАТЕСІ',
                'RESTORATION ERROR'
            );
        },

        get getTaskRepairSuccessfulTitle(): string {
            return ''
        },

        get getReportCheckingTitle(): string {
            return i18n.choose(
                'ПРОВЕРКА ОТЧЕТА',
                'ЕСЕП ТЕКСЕРІЛУДЕ',
                'REPORT IS BEING CHECKED'
            );
        }
    },

    error: {
        get getErrorTitle(): string {
            return i18n.choose('Ошибка сервера', 'Ошибка сервера (каз)', 'Error server');
        },

        get errorCheckStatus(): string {
            return i18n.choose(
                'Не удалось прервать отчёт. Попробуйте ещё раз позже.',
                'Есепті тоқтату мүмкін болмады. Кейінірек қайталап көріңіз.',
                'Failed to cancel the report. Please try again later.'
            );
        },

        get getLoadingZipErrorText(): string {
            return i18n.choose(
                'Не удалось скачать отчёт. Пожалуйста, попробуйте позже.',
                'Не удалось скачать отчёт. Пожалуйста, попробуйте позже. (каз)',
                'Failed to download the report. Please try again later.'
            );
        }
    },

    buttons: {
        get loadReportTaskZip(): string {
            return i18n.choose(
                'Скачать файл',
                'Скачать файл (каз)',
                'Download file'
            );
        },
        get refreshReportTask(): string {
            return i18n.choose(
                'Обновить',
                'Обновить (каз)',
                'Refresh'
            );
        },

        get requestCancelReportTask(): string {
            return i18n.choose(
                'Отменить загрузку',
                'Жүктеуді болдырмау',
                'Request cancel'
            );
        },

        get generateReportTask(): string {
            return i18n.choose(
                'Повторно сформировать',
                'Қайтадан қалыптастыру',
                'Generate again'
            );
        }
    },
    generatorType: {
        get getTariffTitle(): string {return i18n.choose('Тарификационный список', 'Тарификационный список (каз)', 'Tarification');},
        get getStaffTabTitle(): string {return i18n.choose('Штатное расписание', 'Штатное расписание (каз)', 'Staffing table');},
        get getStaffTabEduTitle(): string { return i18n.choose('Штатное расписание (образование)', 'Штатное расписание (образование) (каз)', 'Staffing table (edu)');},
        get getStaffTabEducationTitle(): string { return i18n.choose('Сводный отчет по программам', 'Бағдарламалар бойынша жиынтық есептемесі', 'Staffing table (education)');}
    }
}
Vue.use(BootstrapVueIcons);
@Component({
    name: 'TablePage',
    components: {
        Overlay,
        SvgIcon,
    },
})

export default class TablePage extends ComponentBase  {
    constructor() {
        super('');
    }
    // /region Model, properties
    @Model('modelChangeEvent', {
        type: [],
        required: true,
        default: () => [],
    })
    readonly reportTasks!: SummaryReport.ReportTask[];

    @Prop({
        type: Boolean,
        required: false,
        default: () => false,
    })
    public readonly isEducation!: boolean;
    // endregion

    @Prop({
        type: Boolean,
        required: true,
        default: () => false,
    })
    public readonly loadingData!: boolean;
    // endregion

    @Prop({
        type: Array,
        required: true,
        default: () => [],
    })
    public readonly listOfBudgetVariants!: BudgetVariants[]
    // endregion

    @Prop({
        type: Array,
        required: true,
        default: () => [],
    })
    public readonly optionsDataType!: Array<Comp.DropdownItemDef<string>>

    @Prop({
        type: Array,
        required: true,
        default: () => [],
    })
    public readonly optionsEduOrgType!: Array<Comp.DropdownItemDef<string>>

    @Prop({
        type: Boolean,
        required: true,
        default: () => false,
    })
    public readonly isExported!: boolean;
    // endregion

    // region Misc data
    private get userId(): string {
        return auth.user.sub;
    }

    public EnumStatus = SummaryReport.EnumStatus;

    get translates() { return translates }

    @Watch('reportTasks', { immediate: true, deep: true })
    onReportTasksChanged(newTasks: SummaryReport.ReportTask[]) {
        this.tasks = [...newTasks];
    }

   private tasks: SummaryReport.ReportTask[] = []

    public get renderTask(): SummaryReport.ReportTask[] {
       return this.tasks
    }

    public refreshTask() {this.$emit('update-report-tasks');}

    private timeFormat(date: Date | null): string {
        if (!date) return ''

        return dateTimeFormat(this.$i18n.locale).format(date);
    }

    getProcessTaskVariant(status: EnumStatus): string {
        switch (status) {
            case EnumStatus.NEW: return 'info';
            case EnumStatus.IN_PROGRESS: return 'info'
            case EnumStatus.SUCCESSFUL: return 'success';
            case EnumStatus.SUCCESS_REPAIR: return 'success';
            case EnumStatus.IN_REPAIRING: return 'primary';
            default: return 'secondary';
        }
    }

    getStatusColor(status: EnumStatus): string {
        switch (status) {
            case EnumStatus.EXPORTED: return '#0fb15a'
            case EnumStatus.SUCCESSFUL: return '#0fb15a';
            case EnumStatus.SUCCESS_REPAIR: return '#0fb15a';
            case EnumStatus.FAILED: return '#dc3545';
            case EnumStatus.TASK_CANCELED: return '#dc3545';
            case EnumStatus.FAILED_REPAIR: return '#dc3545';
            case EnumStatus.RESTORE_DTO_BROKEN: return '#5c9fdc';
            case EnumStatus.NEW: return '#6c757d';
            case EnumStatus.RETRYING: return '#5c9fdc';
            default: return '#6c757d';
        }
    }

    getStatusText(status: EnumStatus): string {
        switch (status) {
            case EnumStatus.EXPORTED: return translates.action.getExportedTitle
            case EnumStatus.SUCCESSFUL: return translates.action.getProcessedTitle;
            case EnumStatus.FAILED: return translates.action.getInterruptedTitle;
            case EnumStatus.NEW: return translates.action.getQueueITitle;
            case EnumStatus.RETRYING: return translates.action.getRetryTitle;
            case EnumStatus.CANCEL_REQUESTED: return translates.action.getRequestedCancelTitle;
            case EnumStatus.TASK_CANCELED: return translates.action.getTaskCanceledTitle;
            case EnumStatus.FAILED_REPAIR: return translates.action.getTaskFailRepairTitle;
            case EnumStatus.SUCCESS_REPAIR: return translates.action.getTaskRepairSuccessfulTitle;
            case EnumStatus.RESTORE_DTO_BROKEN: return translates.action.getReportCheckingTitle;
            default: return '--';
        }
    }

    getBoolFieldStatus(status: boolean): string {
        return i18n.choose(status ? 'Да' : 'Нет', status ? 'Иә' : 'Жоқ', status ? 'Yes' : 'No');
    }

    getAnimated(status: EnumStatus): boolean {
        switch (status) {
            case EnumStatus.IN_PROGRESS: return true
            case EnumStatus.IN_REPAIRING: return true
            default: return false;
        }
    }

    getProcessAnimated(status: EnumStatus): boolean {
        switch (status) {
            case EnumStatus.IN_PROGRESS: return false
            case EnumStatus.IN_REPAIRING: return false
            default: return true;
        }
    }

    getPlanPeriod(year: number) {
        return `${year}-${year + 2}`
    }

     getBudgetProgramText(prg: string | null): string {
        if (!prg) return ''
        let code = String(prg);
        while (code.length < 3) code = '0' + code;
        return code
    }

    isActiveToLoadReport(task: SummaryReport.ReportTask): boolean {
        const userActive = task.userId === this.userId;
        const reportIsReady = task.status === SummaryReport.EnumStatus.SUCCESSFUL;
        return userActive && reportIsReady;
    }

    isActiveToSendRepairedReport(task: SummaryReport.ReportTask): boolean {
        const userActive = task.userId === this.userId;
        const taskIsRepaired = task.status === SummaryReport.EnumStatus.SUCCESS_REPAIR;
        return userActive && taskIsRepaired;
    }

    showIcon(status: SummaryReport.EnumStatus): boolean {
        return status === SummaryReport.EnumStatus.SUCCESS_REPAIR;
    }

    isActiveToCancelReport(task: SummaryReport.ReportTask): boolean {
        const userActive = task.userId === this.userId;
        const status = task.status;
        const canCancel = status === SummaryReport.EnumStatus.IN_PROGRESS || status === SummaryReport.EnumStatus.NEW || status === SummaryReport.EnumStatus.RETRYING;
        return userActive && canCancel;
    }

     isActivePanel(task: SummaryReport.ReportTask): boolean {
        return this.isActiveToLoadReport(task) ||
               this.isActiveToCancelReport(task)
    }

    getSubGuCodes(array: Array<string>, all: boolean = false): string {
        const cleaned = array[0] === '' ? array.slice(1): array
        if (all) {
          return  cleaned.join(', ')
        }

        if (cleaned.length > 5) {
            return cleaned.slice(0, 5).join(', ')
        }

        return cleaned.join(', ')
    }

    private getBudgetVariantTitle(variantUuid: string): string {
        const variant = this.listOfBudgetVariants.find(variant => variant.variantUuid === variantUuid)

        if (!variant) {
            return variantUuid
        }
        return  this.localize(
            () => (`${variant.nameRu}`|| ''),
            () => (`${variant.nameKk}`|| ''),
            () => (`${variant.nameRu}`|| '')
        )

    }

    getDataTypeTitle(code: string | null) {
        const option = this.optionsDataType.find(dataType => dataType.value === code)
        if (!option) {
            return code
        }
        return option.text
    }

    getEduOrgTypeTitle(code: string | null) {
        const option = this.optionsEduOrgType.find(dataType => dataType.value === code)
        if (!option) {
            return code
        }
        return option.text
    }

     generatorTypeTitle(type: GeneratorTypeEnum): string {
        switch (type) {
            case GeneratorTypeEnum.SVD_ORG_UO: return translates.generatorType.getStaffTabTitle
            case GeneratorTypeEnum.SVD_ORG_TC: return translates.generatorType.getTariffTitle
            case GeneratorTypeEnum.SVD_EDU: return translates.generatorType.getTariffTitle
            case GeneratorTypeEnum.SVD_EDU_SHR: return translates.generatorType.getStaffTabEduTitle
            case GeneratorTypeEnum.SVD_EDU_UNIFIED: return translates.generatorType.getStaffTabEducationTitle
            default: return ''
        }
    }

    private getLoadedZipTitle(task: SummaryReport.ReportTask): string {
        const period = this.getPlanPeriod(task.year)
        const variant = this.getBudgetVariantTitle(task.variantUuid)
          return `СО_${period}_${variant}.zip`

    }

    private get fields(): Array<any> {
        const baseFields = [
            { key: 'id', label: 'id', thClass: 'text-center', tdClass: 'text-center' },
            { key: 'generatorType', label: translates.tableField.reportTitle, thClass: 'text-center', tdClass: 'text-center' },
            { key: 'year', label: translates.tableField.planPeriodTitle, thClass: 'text-center', tdClass: 'text-center' },
            { key: 'region', label: translates.tableField.regionTitle, thClass: 'text-center', tdClass: 'text-center' },
            { key: 'dataType', label: translates.tableField.dataTypeTitle, thClass: 'text-center', tdClass: 'text-center' }
        ]
        if (this.isEducation) {
            baseFields.push(
                {key: 'eduOrgType', label: translates.tableField.eduOrgTypeTitle, thClass: 'text-center', tdClass: 'text-center'},
                {key: 'codeGu', label: translates.tableField.codeGuTitle, thClass: 'text-center', tdClass: 'text-center'},
                {key: 'subGuCodes', label: translates.tableField.subGuCodesTitle, thClass: 'text-center', tdClass: 'text-center'}
            )
        }
        baseFields.push(
            {key: 'abp', label: translates.tableField.abpTitle, thClass: 'text-center', tdClass: 'text-center'},
            {key: 'variantUuid', label: translates.tableField.variantUuidTitle, thClass: 'text-center', tdClass: 'text-center'},
            {key: 'budgetProgram', label: translates.tableField.budgetProgramTitle, thClass: 'text-center', tdClass: 'text-center'},
            {key: 'detailedReport', label: translates.tableField.detailedReportTitle, thClass: 'text-center', tdClass: 'text-center'},
            {key: 'includeDepartment', label: translates.tableField.includeDepartmentTitle, thClass: 'text-center', tdClass: 'text-center'},
            {key: 'userName', label: translates.tableField.userTitle, thClass: 'text-center', tdClass: 'text-center'},
            {key: 'createDate', label: translates.tableField.createDateTitle, thClass: 'text-center', tdClass: 'text-center'},)

        if (this.isExported) {
            baseFields.push({key: 'exportDate', label: translates.tableField.exportDateTitle, thClass: 'text-center', tdClass: 'text-center'})
        }

        baseFields.push({key: 'progress', label: translates.tableField.statusTitle, thClass: 'text-center', tdClass: 'text-center'})
        baseFields.push({key: 'actions', label: translates.tableField.actionTitle, thClass: 'text-center', tdClass: 'text-center'})

        return baseFields

    }

    async generateReportTask(task: SummaryReport.ReportTask): Promise<void> {
        try {
            await axios.get(`/api/budget/staffing_table/task/${task.id}/queue`);
        } catch (error) {
            const status = error.response?.status;
            switch (status) {
                case 409:
                    this.toast('info', '', translates.action.getRefreshStatusTitle);
                    break;

                default:
                    this.toast(
                        'danger',
                        translates.error.getErrorTitle,
                        translates.error.errorCheckStatus
                    );
                    break;
            }

            console.error('Cancel task failed', error);
        } finally {
            setTimeout(() => {
                this.refreshTask();
            }, 600);
        }
    }

    async cancelReportTask(task: SummaryReport.ReportTask): Promise<void> {
        try {
            await axios.patch(`/api/budget/staffing_table/task/${task.id}/cancel-requested`);

        } catch (error) {
            const status = error.response?.status;
            switch (status) {
                case 409:
                    this.toast('info', '', translates.action.getRefreshStatusTitle);
                    break;

                default:
                    this.toast(
                        'danger',
                        translates.error.getErrorTitle,
                        translates.error.errorCheckStatus
                    );
                    break;
            }

            console.error('Cancel task failed', error);
        } finally {
            this.refreshTask();
        }
    }

    loadExcelReportFromS3(task: SummaryReport.ReportTask) {
        const reportId = task.id
        const zipTitle =  this.getLoadedZipTitle(task)

        if (!reportId) {
            console.error('Cannot load report from S3: report ID is empty');
            this.toast('danger', translates.error.getErrorTitle, translates.error.getLoadingZipErrorText);
            return;
        }

        axios.get(`/api/budget/staffing_table/summary-report-zip?id=${reportId}`, { responseType: 'blob' })
            .then(response => {
                if (response.status !== 200) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                return new Promise<void>((resolve) => {
                    const blob = new Blob([response.data], { type: 'application/zip' });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', zipTitle);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                    resolve();
                });
            })
            .then(() => {
                this.refreshTask()
            })
            .catch(e => {
                console.error('Failed to download report from S3', e);
                this.toast('danger', translates.error.getErrorTitle, translates.error.getLoadingZipErrorText);
            });
    }
}
